import { render, staticRenderFns } from "./literatureLecture.vue?vue&type=template&id=35ac3264&scoped=true&"
import script from "./literatureLecture.vue?vue&type=script&setup=true&lang=js&"
export * from "./literatureLecture.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./literatureLecture.vue?vue&type=style&index=0&id=35ac3264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac3264",
  null
  
)

export default component.exports